<template>
    <div>
        <div v-for="item in projNow" :key="item.id">
            <!-- Title page -->
            <div>
                <div class="title-img">
                    <img :src="require('../../assets/designProjects/' + item.img)">
                    <div class="title-img-overlay"></div>
                </div>
                <b-container fluid class="title-des">
                    <b-col class="col-lg-3 col-md-4 col-sm-6">
                        <h1 class="text-info text-left">{{ item.title }}</h1>
                        <p class="text-white">{{ item.description }}</p>
                    </b-col>
                </b-container>
            </div>
            <!-- Header -->
            <Header></Header>
            <!-- Project Info -->
            <b-container class="d-none d-lg-block d-xl-block content-left">
                <b-col class="col-lg-2">
                    <div class="my-5">    
                        <h5 class="text-info">Collaboration</h5>
                        <p>Hypothetical case on <br>{{ item.collaboration }}.</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Type</h5>
                        <p>{{ item.type }} <br>{{ item.skill }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Duration</h5>
                        <p>{{ item.time }} <br>{{ item.duration }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Team</h5>
                        <p>Akari Takada <br>Andrés Restrepo <br>Eda Karaosmanoğlu <br>Rengarajan Manivannan </p>
                    </div>
                    <!-- <div class="my-5">
                        <h5 class="text-info">Skills</h5>
                        <p>edit here</p>
                    </div> -->
                </b-col>
            </b-container>
            <!-- Overview -->
            <b-container class="my-5">
                <h2 class="my-4 text-light">Overview</h2>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">About HAPRO</h5>
                            <h3>Manufacturer in two distinct industries.</h3>
                            <p>HAPRO is a ‘car roof box’ and ‘sunbed’ manufacturer, who is a key player in the travel and beauty industries. They believe in the potential of wellness and leisure.</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col md class="my-2 p-0 mr-md-4">
                            <img class="rounded-img" src="../../assets/designProjects/sleepbox/roofbox.png" alt="">
                            <p class="text-right w-100"><small>Source: HAPRO</small></p>
                        </b-col>
                        <b-col md class="my-2 p-0 mr-md-4">
                            <img class="rounded-img" src="../../assets/designProjects/sleepbox/suntan.png" alt="">
                            <p class="text-right w-100"><small>Source: HAPRO</small></p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-container>
            <!-- Problem -->
            <b-container class="bg-custom py-5 my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col md class="my-2">
                            <h5 class="text-info">Problem: HAPRO</h5>
                            <h3>Diversifying HAPRO's portfolio.</h3>
                            <p>Aligning HAPRO's strengths for manufacturing large plastic products with the transforming trends in the travel industry leads to an opportunity.</p>
                        </b-col>
                        <b-col md class="my-2">
                            <h5 class="text-info">Problem: Users</h5>
                            <h3>Evolving travel needs.</h3>
                            <p>The pandemic and unpredictable restrictions caused travelers to seek for a weekend escape from daily routine closer to home.</p>
                        </b-col>
                    </b-row>
                    <!-- <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/evo/context.png" alt="">
                    </b-row> -->
                </b-col>
            </b-container>
            <b-container class="bg-problem py-5 my-5">
                <h3 class="text-white m-0">How to develop HAPRO's travel products into travel and wellness experiences?</h3>
            </b-container>
            <!-- Solution -->
            <b-container class="my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Solution</h5>
                            <h3>SleepBox.</h3>
                            <p>A compact car roof box that duals as a tent, allowing users to camp with luxury and comfort.</p>
						</b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/sleepbox/userFlow1.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">Storage and tent in one.</h4>
                            <p class="text-white">Travel supplies are stored in the SleepBox, just like in any HAPRO roofbox, and can easily be carried to the campsite. Of course, there is no need to pack a tent.</p>
                        </div>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h4>Easy set up.</h4>
                            <p>Setting up the tent is easy even for first-time campers. All you need to do is to raise the roof and roll down the fabric.</p>
						</b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/sleepbox/userFlow2.png" alt=""></b-col>
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/sleepbox/userFlow3.png" alt=""></b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/sleepbox/userFlow4.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">Convenient getaway.</h4>
                            <p class="text-white">Allows a costless travel into nature, which is pandemic-friendly, and fits with the increasingly flexible work culture.</p>
                        </div>
                    </b-row>
                </b-col>
            </b-container>
        </div>
        <footerProjects></footerProjects>
    </div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')

  var now = 'sleepbox';

  export default {
    name: 'sleepbox',
    title: 'SleepBox',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>